import React from 'react'
import Match from '../images/matchdates.PNG'
import Shoppromo from '../components/Shoppromo'
import Layout from '../layout/Mainlayout'
import TreeDayMatches from '../components/TreeDayMatches'




export default function Home() {


    return (
        <Layout>
            <div className='bg-dwam min-h-screen flex flex-col p-5 items-center space-y-8 divide-y-[3px] divide-yakam'>

                <div className='w-full '>
                    <Shoppromo />
                </div>

                <div className=' container mx-auto flex flex-col justify-center space-y-4 '>

                    <h1 className=' text-chwaram text-center text-4xl bg drop-shadow-lg'>خشتەی یاریەکان </h1>
                    <div className='md:w-full justify-center text-center'>
                        <img src={Match} alt='matchs' className=' object-contain rounded-b-lg shadow-md ' />
                    </div>


                    <div className='flex  flex-col md:flex-row justify-center w-full'>

                        <TreeDayMatches />




                    </div>

                </div>


            </div>
        </Layout>
    )
}
